import { MDBInput, MDBSelect, MDBTextArea } from 'mdb-react-ui-kit'
import React from 'react'

function NotificationListDetails() {
    return (
        <>
            <MDBTextArea className='mb-3' label="Notes" rows="{4}" />
            <MDBInput
                label="name@example.com"
                id="email"
                type="text"
            />
            <small>Seperate email addresses by commas</small>
        </>
    )
}

export default NotificationListDetails;